import React from 'react'
import Checkbox from './checkbox/checkbox.component';

function Checkboxes({data, handleCheckboxChange}) {

    return (
        <>
            {
                data.map(item => <Checkbox key={item.id} item={item} handleCheckboxChange={handleCheckboxChange}/>)
            }
        </>
    )
}

export default Checkboxes
